import { z } from "zod";

/**
 * ObraSchema
 *
 * porEmpreendimento define a forma de cadastro: por centro de custo (padrão)
 * ou por empreendimento, onde o centro de custo é o do empreendimento.
 */

export const ObraSchema = z.object({
  tipo: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }).default(1),
  idFuncionarioAprovado: z.coerce.number().nullable().default(null),
  idFuncionarioRevisado: z.coerce.number().nullable().default(null),
  porEmpreendimento: z.boolean().default(false),
  idEmpreendimento: z.coerce.number().nullable().default(null),
  idCentroCusto: z.coerce.number().nullable().default(null),
  historicoRevisoes: z.string().nullable().default(null),
  apresentacaoObra: z.string().nullable().default(null),
  processo: z.string().nullable().default(null),
  pctPdeFadDatec: z.string().nullable().default(null),
  meios: z.string().nullable().default(null),
}).superRefine((form, ctx) => {
  if (form.porEmpreendimento) {
    if (!form.idEmpreendimento) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['idEmpreendimento'], message: 'Este campo deve ser preenchido!' });
    }
  } else if (!form.idCentroCusto) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['idCentroCusto'], message: 'Este campo deve ser preenchido!' });
  }
});

/**
 * ObraForm
 */

export type ObraForm = z.infer<typeof ObraSchema>;
